<template>
  <ul class="nav nav-pills nav-fill">
    <li class="nav-item" v-for="(tab, i) in tabs" :key="tab.title" @click="$emit('input', i)">
      <a
        class="nav-link"
        :class="{ active: i === value }"
        style="cursor: pointer !important;"
      >{{ tab.title }}</a>
    </li>
  </ul>
</template>

<script>
export default {
  name: "Tabs",
  props: {
    tabs: {
      required: true,
      type: Array
    },
    value: {
      type: Number
    }
  },
  computed: {
    current() {
      return this.tabs[this.value];
    }
  }
};
</script>

<style scoped lang="scss">
.nav-tabs {
  justify-content: space-between;

  .nav-item {
    width: 23%;
    white-space: nowrap;
    .nav-link {
      background-color: #ff9a22;
      color: #fff;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 15px 0;
      &.active {
        background-color: #fff;
        color: #ff9a22;
      }
    }
  }
}
</style>
